<style scoped lang="less" >
.v-application .text-h4 {
  font-family: "Prompt", sans-serif !important;
  font-size: 24px !important;
}
.text-spacing {
  letter-spacing: 0px !important;
}
.legend-con {
  font-family: "Prompt", sans-serif !important;
  display: inline-block;

  ul {
    list-style: none;
  }

  li {
    display: flex;
    align-items: center;
    margin-bottom: 4px;

    span {
      display: inline-block;
    }

    span.chart-legend {
      width: 25px;
      height: 25px;
      margin-right: 10px;
    }
  }
}
</style>

<template>
  <v-container fluid>
    <div
      class="text-h4 font-weight-black primary--text text-spacing"
      color="blue"
    >
      รายงาน ตช.
    </div>
    <v-divider class="my-2"></v-divider>
    <v-row>
      <v-col cols="12" lg="4">
        <v-combobox
          class="mx-3"
          label="โรงกำจัดมูลฝอย"
          solo
          :items="dataDestroy"
          v-model="destroySaerch"
          item-text="DESTROYER_NAME"
          item-value="DESTROYER_ID"
          return-object
        ></v-combobox>
      </v-col>
      <v-col cols="12" lg="6">
        <div class="d-flex justify-center">
          <h4 class="ma-3">เดือน</h4>
          <div class="mr-5">
            <v-dialog
              ref="dialog"
              v-model="modal"
              :return-value.sync="nowMonth"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="nowMonth"
                  label=""
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  class="mt-n2"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="nowMonth"
                type="month"
                locale="th"
                scrollable
              >
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="modal = false">
                  ยกเลิก
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.dialog.save(nowMonth)"
                >
                  ตกลง
                </v-btn>
              </v-date-picker>
            </v-dialog>
          </div>
          <v-btn class="ml-1" color="error" @click="clickClear">
            ล้าง<v-icon dark> mdi-monitor-clean </v-icon>
          </v-btn>
          <v-btn class="ml-1" color="success" @click="clickSearch">
            ค้นหา<v-icon dark>mdi-card-search-outline </v-icon>
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" lg="12">
        <v-container>
          <docment-report-dash
            v-if="getindex_wasteDocument != ''"
            :Data="getindex_wasteDocument"
          />

          <div
            v-else
            class="font-weight-black primary--text text-spacing"
            color="blue"
          >
            ไม่พบข้อมูล
          </div>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import DocmentReportDash from "../_DocumentReport/DocumentReportDash";
import { mapMutations, mapGetters } from "vuex";
import moment from "moment";
export default {
  components: {
    DocmentReportDash,
  },
  name: "WasteReport",
  data: () => ({
    picker: new Date().toISOString().substr(0, 7),
    momentFormat: {
      // Date to String
      stringify: (date) => {
        return date
          ? moment(date).add(543, "year").locale("th").format("LL")
          : "";
      },
      // String to Date
      parse: (value) => {
        return value ? moment(value, "LL").toDate() : null;
      },
    },
    nowMonth: new Date().toISOString().substr(0, 7),
    dataDestroy: [],
    destroySaerch: "",
    newdesserts: [],
    modal: false,
  }),
  watch: {},
  computed: {
    getindex_wasteDocument() {
      // console.log(this.newdesserts);
      return this.newdesserts.map((item, index) => ({
        ...item,
        index: index + 1,
        // create_date: moment(CREATE_DATE)
        //   .add(543, "years")
        //   .format("DD/MM/YYYY hh:mm:ss", true),
      }));
    },
  },
  methods: {
    ...mapMutations({
      SET_ALL: "SummaryCollectRemoval/SET_ELEMENT",
    }),
    searchCollect_Removal() {
      //console.log(this.picker);
      this.SET_ALL({ key: "Y_M", value: this.picker });
      this.$router.push({ path: "/SummaryMonth" });
    },
    Transfer_Detail() {
      this.$router.push({ path: "/Transfer-Waste" });
    },
    clickSearch() {
      //   console.log(moment(this.nowMonth).format("YYYY-MM-DD"));
      //   console.log(this.destroySaerch);
      if (!this.destroySaerch) {
        this.$swal({
          title: "กรุณากรอกโรงกำจัด",
          icon: "warning",
          confirmButtonColor: "#d33",
          confirmButtonText: "ปิด",
        });
      } else {
        let sendData = {
          year: moment(this.nowMonth).format("YYYY"),
          month: moment(this.nowMonth).format("MM"),
          des_id: this.destroySaerch.DESTROYER_ID,
        };
        console.log(sendData);
        this.$token_api
          .post("/document-destroy", sendData)
          .then((res) => {
            console.log(res.data.data);
            this.newdesserts = res.data.data;
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },
    clickClear() {
      this.nowDat = new Date();
      this.destroySaerch = "";
      this.newdesserts = " ";
      //   console.log(this.nowMonth);
      //   console.log(this.destroySaerch);
    },
    searchDestroy() {
      this.$token_api
        .get("/get-destroy")
        .then((res) => {
          console.log(res.data.data);
          this.dataDestroy = res.data.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
  mounted() {},
  created() {
    let sendData = {
      time: moment(this.nowMonth).format("YYYY-MM-DD"),
      des_id: 1,
    };
    // console.log(sendData);

    this.$token_api
      .post("/document-destroy", sendData)
      .then((res) => {
        this.dataDestroy = res.data.data;
      })
      .catch((err) => {
        console.log(err);
      });
    this.searchDestroy();
  },
  filters: {
    delimeter(data) {
      let y = parseFloat(data).toFixed(2);
      let x = y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      return x;
    },
    formatDate(data) {
      return moment(data).add(543, "year").format("DD-MM-YYYY");
    },
  },
};
</script>